"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthCode = void 0;
function isAuthCode(value) {
    var isValid = true;
    var errors;
    var authCodeRegex = /^([A-Z0-9-]{7})$/;
    return !value || !value.match(authCodeRegex)
        ? {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    isValidAuthCode: "false",
                },
            },
        }
        : {
            isValid: isValid,
            errors: errors,
        };
}
exports.isAuthCode = isAuthCode;
